import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-data-modal',
    templateUrl: './data-modal.component.html',
    styleUrls: ['./data-modal.component.scss'],
})
export class DataModalComponent {
    @Input() data: any;
    displayDataObject: any;
    displayData: any = '';
    highlightedDisplayData: SafeHtml | null = null;
    parsedDisplayData: any = '';
    constructor(private sanitizer: DomSanitizer) {}
    ngOnInit() {
        console.log('THIS.DATA', this?.data);
        this.displayDataObject = JSON.parse(JSON.stringify(this.data));
        const payload = this.displayDataObject?.data;
        console.log(this.displayDataObject);
        if (this.displayDataObject.pageType == 'deeplink') {
            this.displayData = this.displayDataObject.data;
        } else if (this.displayDataObject.pageType == 'dashboard') {
            this.displayData = JSON.stringify(this.displayDataObject.data, null, 4);
        } else if (this.displayDataObject.pageType == 'plans') {
            this.displayData = JSON.stringify(
                this.displayDataObject.data.map((data: any) => {
                    console.log('DATA NAME', data.name);
                    return data.name;
                }),
                null,
                4
            );
        } else if (this.displayDataObject.pageType == 'audit') {
            this.displayData = JSON.stringify(payload, null, 4);
            this.highlightedDisplayData = this.getHighlightedJSON(this.displayData);
            console.log('THIS.AUDIT', this.data, '************', this.displayData);
        } else if (this.displayDataObject.pageType == 'uitemplate') {
            console.log('DATA MODAL COMPONENT', this.displayDataObject.data);
            this.displayData = JSON.stringify(this.displayDataObject.data, null, 4);
        } else if (this.displayDataObject.pageType === 'scheduleItems') {
            console.log('THIS Schedule Items', this.data, '**********', this.displayDataObject);

            if (this.displayDataObject?.data?.data) {
                this.displayData = this.displayDataObject.data.data;
                console.log('this.displayDataObject?.data?.data', this.displayData);
            } else if (this.displayDataObject?.data) {
                this.displayData = this.displayDataObject.data;
                console.log('this.displayDataObject?.data', this.displayData);
            }

            if (this.displayData) {
                if (typeof this.displayData === 'string') {
                    try {
                        const trimmed = this.displayData.trim();

                        // Check if it's "24x7" special case
                        if (trimmed === '24x7') {
                            this.parsedDisplayData = '24x7';
                        } else {
                            this.parsedDisplayData = JSON.parse(trimmed);
                            console.log('? Parsed Display Data (from string):', this.parsedDisplayData);
                        }
                    } catch (e) {
                        console.error('? Invalid JSON in displayData (string case):', e);
                    }
                } else if (Array.isArray(this.displayData)) {
                    // Already a parsed array
                    this.parsedDisplayData = this.displayData;
                    console.log('? Parsed Display Data (already array):', this.parsedDisplayData);
                } else {
                    console.warn('?? Unexpected displayData format:', this.displayData);
                }
            }
        } else if (this.displayDataObject.pageType === 'multiSchedule') {
            console.log('?? Multi Schedule:', this.displayDataObject);

            const rawData = this.displayDataObject?.data?.data ?? this.displayDataObject?.data;

            if (typeof rawData === 'string') {
                if (rawData === '24x7') {
                    this.displayData = '24x7';
                    this.parsedDisplayData = '24x7';
                } else {
                    try {
                        this.displayData = rawData;
                        this.parsedDisplayData = JSON.parse(rawData.trim());
                        console.log('? Parsed Multi Schedule Data:', this.parsedDisplayData);
                    } catch (e) {
                        console.error('? Invalid JSON in Multi schedule data:', e);
                    }
                }
            } else if (Array.isArray(rawData)) {
                // Already parsed array
                this.parsedDisplayData = rawData;
                console.log('? Multi Schedule Data (already array):', this.parsedDisplayData);
            } else {
                console.warn('?? Unexpected data format for Multi schedule:', rawData);
            }
        } else if (this.displayDataObject.pageType === 'jiotvplans') {
            console.log('DATA MODAL COMPONENT', this.displayDataObject.data);
            this.displayData = JSON.stringify(this.displayDataObject.data, null, 4);
        }
    }
    getHighlightedJSON(jsonString: string): SafeHtml {
        let highlighted = jsonString
            // Keys
            .replace(/"(.*?)":/g, '<span class="json-key">"$1"</span>:')
            // Strings
            .replace(/: "(.*?)"/g, ': <span class="json-string">"$1"</span>')
            // Numbers
            .replace(/: (\d+(\.\d+)?)/g, ': <span class="json-number">$1</span>')
            // Booleans
            .replace(/: (true|false)/g, ': <span class="json-boolean">$1</span>')
            // Null
            .replace(/: null/g, ': <span class="json-null">null</span>')
            // Arrays (match [ ... ] including inner content)
            .replace(/: (\[[^\]]*\])/g, ': <span class="json-array">$1</span>');

        return this.sanitizer.bypassSecurityTrustHtml(highlighted);
    }
}
